"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var variantConfig = {
  brandLight: {
    background: 'var(--color-brand-light)',
    whiteCopy: false,
    allowBrandColour: true,
    defaultBorder: false
  },
  brandLightWithBorder: {
    background: 'var(--color-brand-light)',
    whiteCopy: false,
    allowBrandColour: true,
    defaultBorder: true
  },
  whiteWithBorder: {
    background: 'var(--color-global-white)',
    whiteCopy: false,
    allowBrandColour: true,
    defaultBorder: true
  },
  grey: {
    background: 'var(--color-greys-grey2)',
    whiteCopy: false,
    allowBrandColour: true,
    defaultBorder: false
  },
  brand: {
    background: 'var(--color-brand-mid)',
    whiteCopy: true,
    allowBrandColour: false,
    defaultBorder: false
  },
  black: {
    background: 'var(--color-global-black)',
    whiteCopy: true,
    allowBrandColour: true,
    defaultBorder: false
  },
  blackWithBorder: {
    background: 'var(--color-global-black)',
    whiteCopy: true,
    allowBrandColour: true,
    defaultBorder: true
  }
};
var _default = exports["default"] = variantConfig;